import dayjs from 'dayjs'
import { PricingType, pricingTypeName } from '../../common/constants'
import { centsToDollarsDisplay } from '../displayFormatters'
import { getAdminErrorMessage } from './adminErrorModel'

export const NotAvailable = '—'

export type JobLookupRequest = {
  tenantId: number
  jobId: number
}

export type WorkareaLabel = {
  workareaId: number
  workareaName: string
  groupName: string
}

export const formatCents = (cents: number | null): string => {
  return centsToDollarsDisplay(cents) ?? NotAvailable
}

export const formatVisitDate = (visitDate: string | null): string => {
  if (visitDate === null) {
    return NotAvailable
  }
  return dayjs(visitDate.slice(0, 10)).format('MM/DD/YYYY')
}

export const workareaTitle = (workarea: WorkareaLabel): string => {
  const name = workarea.workareaName || `Workarea ${workarea.workareaId}`
  return workarea.groupName ? `${workarea.groupName} — ${name}` : name
}

export const workareaPricingLabel = (workarea: { pricingType: PricingType }): string => {
  return pricingTypeName(workarea.pricingType) ?? NotAvailable
}

export const isJobNotFoundError = (error: unknown): boolean => {
  return (error as { response?: { status?: number } })?.response?.status === 404
}

export const getJobNotFoundMessage = (error: unknown, request: JobLookupRequest | null): string => {
  const fallback = request === null
    ? 'That job was not found for this tenant.'
    : `No job #${request.jobId} found for tenant ${request.tenantId}.`
  return getAdminErrorMessage(error, fallback)
}
